import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';
import { UsuarioFilter } from '../filter';
import { UsuarioAgrupamentoPerfil } from '../usuario-agrupamento-perfil';

@Injectable({
    providedIn: 'root'
})
export class UsuarioAgrupamentoHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                private configServerService: ConfigServerService) {
        this.pathApi = `${this.configServerService.getPathApi()}/usuario/0/agrupamento`
    }

    /** Pesquisa os usuários agrupados pelo perfil */
    searchAgrupamentosPerfil(filter: UsuarioFilter): Observable<UsuarioAgrupamentoPerfil[]> {
        // Params
        let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<UsuarioAgrupamentoPerfil[]>(`${this.pathApi}/perfil`, {params});
    }
}
